import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const waitingListRoutes: RouteObject = {
  path: ROUTES.waitingList.root,
  children: [
    {
      index: true,
      lazy: async () => {
        const { WaitingListPage } =
          await import('../../../pages/waiting-list/WaitingList.page');

        return { Component: WaitingListPage };
      },
    },
    {
      path: ROUTES.waitingList.details,
      lazy: async () => {
        const { WaitingListDetailsPage } =
          await import('../../../pages/waiting-list/WaitingListDetails.page');

        return { Component: WaitingListDetailsPage };
      },
    },
  ],
};
